import { render, staticRenderFns } from "./FunnelsItemTypeB.vue?vue&type=template&id=32bd1451"
import script from "./FunnelsItemTypeB.vue?vue&type=script&lang=js"
export * from "./FunnelsItemTypeB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports